import React from 'react'
import {Button} from "reactstrap";


const SpecialDelete = ({deleteSpecial, setSpecialDeleteModal}) => {
    const deleteRecord = () =>{
        deleteSpecial();
        setSpecialDeleteModal(false)
    }

    const onclick = () =>{
        setSpecialDeleteModal(false)
    }

    return (
        <div>
            <p >Do you want to delete this Coupon</p>
            <div style={{display:'flex',flexDirection:'row'}}>
            <Button color='info' onClick={deleteRecord}>Yes</Button>
            <Button  onClick={onclick}>No</Button>
            </div>
        </div>
    )
}

export default SpecialDelete
